<div class="modal-header">
    <h5 class="modal-title">Datos de caja fiscal</h5>
    <button type="button" class="btn-close" aria-label="Cerrar" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
    <p class="text-muted mb-3">Estos datos se enviarán a SMART como vendedor/cajero para documentos de impresora fiscal.</p>

    <div class="alert alert-warning mb-0" *ngIf="shouldShowSupportMessage">
        No hay cajas fiscales configuradas para este comercio. Comunícate con soporte para configurar una impresora fiscal antes de emitir documentos fiscales.
    </div>

    <form #sellerForm="ngForm" (ngSubmit)="save()" *ngIf="!shouldShowSupportMessage">
        <div class="mb-3" *ngIf="hasConfiguredPrinters">
            <label class="form-label" for="fiscalPrinter">Impresora fiscal</label>
            <select id="fiscalPrinter" class="form-select" name="printerKey" [ngModel]="selectedPrinterKey" (ngModelChange)="onPrinterChange($event)">
                <option value="">Selecciona una impresora</option>
                <option *ngFor="let printer of availablePrinters" [value]="printer.printerKey || printer.numCajero" [disabled]="printer.enabled === false">
                    {{ printer.nombre }} - Caja {{ printer.numCajero }}
                </option>
            </select>
        </div>

        <div class="mb-3">
            <label class="form-label" for="fiscalSellerCode">Código del vendedor</label>
            <input id="fiscalSellerCode" class="form-control" name="codigo" [(ngModel)]="seller.codigo" maxlength="15" required autocomplete="off" [readonly]="hasConfiguredPrinters" />
        </div>

        <div class="mb-3">
            <label class="form-label" for="fiscalSellerName">Nombre del vendedor/cajero</label>
            <input id="fiscalSellerName" class="form-control" name="nombre" [(ngModel)]="seller.nombre" maxlength="25" required autocomplete="off" [readonly]="hasConfiguredPrinters" />
        </div>

        <div class="mb-0">
            <label class="form-label" for="fiscalCashierNumber">Número de caja</label>
            <input id="fiscalCashierNumber" class="form-control" name="numCajero" [(ngModel)]="seller.numCajero" maxlength="15" required autocomplete="off" [readonly]="hasConfiguredPrinters" />
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" *ngIf="shouldShowSupportMessage" (click)="activeModal.dismiss()">Cerrar</button>
    <button type="button" class="btn btn-primary" *ngIf="!shouldShowSupportMessage" [disabled]="!isValid" (click)="save()">Guardar datos fiscales</button>
</div>
